// Importing react libs
import React from 'react';

// Importing components
import { List as LogList } from 'components/log';

export const Log = () => {
  return <LogList />;
};